import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { getOnboardingCallLink } from '../../../self-upgrade.util';

export const FORMS_PRICE = 199;
export const FORMS_ONBOARDER_SCHEDULING_URL = getOnboardingCallLink(Feature.FORMS);
export const FORMS_PAGE_URL = '/forms/submissions/inbox/all';
export const FORMS_VIDEO_URL = 'https://fast.wistia.com/embed/medias/2mcdggqs2z';
